﻿window.cBuilderEmailWidgetCtrlTelMob = function cBuilderEmailWidgetCtrlTelMob(option) {
    var Me = this;

    window.cBuilderEmailWidgetCtrlTel.call(this, option);

    this.nomWidget = "dxwidgetformtelmob"
    this.icone = "fas fa-mobile-screen";
    this.typChamp = "mob";
    this.nomBt = "Téléphone mobile";
    this.titleBt = "Téléphone mobile<br/>Si l’internaute saisit autre chose qu’un numéro de téléphone mobile, un avertissement apparaîtra."
    this.labelCtrl = "Téléphone mobile"

};